export default __webpack_public_path__ + "engine/assets/YH4LJoy.gif";